<div class="search-sort-container">
    <div
        id="container-sorting-dropdown"
        (mouseenter)="hoveredFunctionalButtonIdx = 1"
        (mouseleave)="hoveredFunctionalButtonIdx = null"
    >
        <img
            [src]="
                'assets/svg/img-db/header/functional-buttons/icon-twin-arrows' +
                (hoveredFunctionalButtonIdx === 1 ? '-white' : '-grey') +
                '.svg'
            "
            alt="icon-twin-arrows"
        />

        <select (change)="onSortOptionChange()" [formControl]="sortControl">
            <option
                class="sorting-option"
                *ngFor="let option of sortingOptions"
                [value]="option"
                [id]="option"
            >
                {{
                    'imgDb.header.functionalButtons.sortingOptions.' + option
                        | translate
                }}
            </option>
        </select>
    </div>
    <div
        class="centered-row container-name-input"
        [ngClass]="{
            'fixed-width': width === 'fixed',
            'dynamic-width': width === 'dynamic',
        }"
    >
        <input
            #searchInput
            (keyup.enter)="onEnter()"
            (keyup)="onEscape($event)"
            (blur)="onBlur()"
            type="text"
            class="form-control"
            [placeholder]="placeholderTranslationKey | translate"
            [formControl]="searchControl"
            aria-label="search for name"
            aria-describedby="basic-addon1"
            id="container-name-input"
        />
        <img
            src="assets/svg/workspace/search-icon.svg"
            alt="search icon"
            (click)="onIconClick()"
            (keyup.enter)="onIconClick()"
        />
    </div>
</div>
